export default function highlightElement(
  element: HTMLElement,
  scrollTo: boolean,
  highlightClass: string = "highlight",
) {
  if (element) {
    element.classList.remove(highlightClass);
    setTimeout(() => {
      element.classList.add(highlightClass);
    }, 200);
    if (scrollTo)
      element.scrollIntoView({
        behavior: "auto", //smooth scrolling not supported in mac browsers
        block: "center",
      });
  }
}
